import * as Sentry from '@sentry/nuxt'

Sentry.init({
    dsn: useRuntimeConfig().public.SENTRY_DSN,
    environment: useRuntimeConfig().public.NODE_ENV,
    sampleRate: 1.0,
    tracesSampleRate: 0,
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 0.01,
    debug: false,
    ignoreErrors: [
        /dynamically imported module/,
        /failed to initialize DateTimeFormat/,
        /Importing a module script failed./,
        /An invalid or illegal string was specified/,
        /The string did not match the expected pattern./,
        /ResourceNotFound/,
        /No error message/,
        /Unauthorized/,
        /RequestFailed/,
        /Failed to fetch dynamically imported module/,
        /Non-Error promise rejection captured with value: Timeout/,
        /Non-Error promise rejection captured with value: Object Not Found Matching/,
        /401/,
        /403/,
        /404/,
        /_nuxt/,
        /Failed to execute 'observe' on 'MutationObserver': parameter 1 is not of type 'Node'./,
        /Cannot use 'in' operator to search for '_leaflet_id' in undefined/,
        /GetAnonymousToken/
    ],
    integrations: [
        Sentry.vueIntegration({
            tracingOptions: {
                trackComponents: true
            }
        }),
        Sentry.replayIntegration({
            networkDetailAllowUrls: [
                window.location.origin,
                'community-authentication',
                'community-feedbacks',
                'community',
                'mappy',
                'legacy-api',
                'pool-detail',
                'pool-prices',
                's3'
            ]
        })
    ]
})
